import * as state from './state.js';

function init() {
  updateCopyright();
  updatePhone();
}

function updateCopyright() {
  const copyright = document.querySelector('p.copyright-text');
  if (copyright === null) {
    return;
  }

  const year = new Date().getFullYear();

  copyright.textContent = `©${year} Saleae, Inc.`;
}

function updatePhone() {
  let element = document.getElementById('sal-phone');
  if (!element) return;

  let phoneNumber = '(510) 984-2463'
  let phoneNumberLink = 'tel:(510) 984-2463';

  const s = state.getState();
  if (s.countryIso !== 'US' || s.languageIso !== 'en') {
    phoneNumber = '+1 510 9842463'
    phoneNumberLink = 'tel:+1 510 9842463'
  }

  element.href = phoneNumberLink;
  element.textContent = phoneNumber;
}

export {
  init,
};